import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { ApplyClass } from 'src/types/api/patentRightsApiTypes';

const applClassColors: { [key: string]: string } = {
  I: colors.primaryOrange_500,
  M: colors.primaryBlue_500,
  D: colors.primaryGreen_700,
};

const Wrapper = styled.div<{ applclass: string }>`
  display: inline-block;
  border-radius: 20px;
  padding: 5px 26px;
  font-size: 12px;
  font-family: NotoSansTC-Medium;
  color: ${colors.white};
  background-color: ${(props) => applClassColors[props.applclass]};
  white-space: nowrap;
  line-height: 1em;
`;

interface IProps {
  type: string;
}

/**
 * 專利類型標籤。
 */
const ApplClassTag: React.FC<IProps> = ({ type }) => {
  return <Wrapper applclass={type}>{ApplyClass[type as keyof typeof ApplyClass]}</Wrapper>;
};

export default ApplClassTag;
